import { Icon } from '@cad-arc';
import React from 'react';
import { Tooltip } from './tooltip';

export const HelpText: React.FC<Omit<React.ComponentProps<typeof Tooltip>, 'children'>> = (
    props
) => {
    const [isHovering, setIsHovering] = React.useState<boolean>(false);
    return (
        <Tooltip {...props} mouseEnterDelay={0}>
            <span
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                style={{ marginLeft: '4px' }}
            >
                <Icon
                    icon={isHovering ? 'TooltipActive' : 'TooltipInactive'}
                    color="text.placeholder"
                />
            </span>
        </Tooltip>
    );
};
